export const Pages = {
	documentViewer: 'documentViewer',
	form:           'form',
	entity:         'entity',
	search:         'search',
	mail:           'mail',
	view:         	'view',
	fullAppHome:   	'home'
} as const;
